import React, { useState, useMemo, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { userhorosreqlist } from "../action/user";


export default function MoreinfoRequests() {
  const history = useNavigate();

  // State to manage request statuses
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);

  const [filters] = useState({
    name: "",
    email: "",
    status: "",
    requestfor: "",
  });

  // Fetch horoscope requests from API
  const fetchMoreinfoRequests = async () => {
    try {
      setLoading(true);
      const response = await userhorosreqlist();
      if (response.data) {
        // Format the data for the table
        const formattedData = response.data.map(item => ({
          ...item,
          _id: item.user_id,
          userid: item.requested_id?.userid || "N/A",
          name: item.requested_id?.mname || "N/A",
          requestedAt: item.createdAt,
          status: item.status || "Pending",
        }));

        setRequests(formattedData);
      }
    } catch (error) {
      console.error("Error fetching horoscope requests:", error);
      setRequests([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMoreinfoRequests();
  }, []);

  // Filter logic
  const processedData = useMemo(() => {
    let data = [...requests];
    return data;
  }, [requests, filters]);

  // Format Date
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    return `${day}/${month}/${year} ${hours}:${minutes}`;
  };

  return (
    <>
      <div className="agent-payment-container">
        <h2 className="font-great-vibes" style={{ margin: "0px 20px 20px", color: "#B21919" }}>
          Full Profile Requests
        </h2>

        {loading ? (
          <div style={{ textAlign: "center", padding: "40px", fontSize: "18px", color: "#666" }}>
            Loading requests...
          </div>
        ) : (
          <table className="payment-table">
            <thead>
              <tr>
                <th>User ID</th>
                <th>Name</th>
                <th>Requested At</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {processedData.length === 0 ? (
                <tr>
                  <td colSpan="6" className="no-data">
                    No records found
                  </td>
                </tr>
              ) : (
                processedData.map((row) => (
                  <tr key={row._id}>
                    <td>
                      <a href={"/batman/" + row.requested_id?.id}>
                        {row.userid}
                      </a></td>
                    <td style={{ textAlign: "left" }}>{row.name}</td>
                    <td>{formatDate(row.requestedAt)}</td>
                    <td>
                      <span
                        className={`status-badge ${row.status === "Approved"
                          ? "success"
                          : row.status === "Rejected"
                            ? "failed"
                            : "open"
                          }`}
                      >
                        {row.status}
                      </span>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        )}
      </div>

      <style jsx>{`
        .agent-payment-container {
          background: #ffecd6;
          padding: 25px;
          border-radius: 12px;
          box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.08);
          margin: 20px;
        }

        .payment-table {
          width: 100%;
          border-collapse: separate;
          border-spacing: 0 10px;
          margin-top: 15px;
          font-size: 18px;
          overflow: hidden;
          border-radius: 10px;
        }

        .payment-table thead tr th {
          text-align: center;
          padding: 14px;
          background: #b21919;
          color: white;
          font-size: 20px;
          font-weight: 600;
        }

        .payment-table thead tr th:first-child {
          border-top-left-radius: 10px;
          border-bottom-left-radius: 10px;
        }

        .payment-table thead tr th:last-child {
          border-top-right-radius: 10px;
          border-bottom-right-radius: 10px;
        }

        .payment-table tbody tr {
          box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
          transition: all 0.2s ease;
          background: white;
        }

        .payment-table tbody tr:hover {
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
        }

        .payment-table td {
          padding: 16px 12px;
          text-align: center;
          font-size: 16px;
        }

        /* Status Badge */
        .status-badge {
          padding: 6px 14px;
          font-size: 14px;
          border-radius: 20px;
          font-weight: 600;
          text-transform: capitalize;
          display: inline-block;
          min-width: 90px;
        }

        .status-badge.success {
          color: #1a8735;
          background-color: #d4edda;
        }

        .status-badge.failed {
          color: #c82333;
          background-color: #f8d7da;
        }

        .status-badge.open {
          color: #ff8f00;
          background-color: #fff3cd;
        }

        .no-data {
          text-align: center;
          padding: 30px;
          color: #999;
          font-style: italic;
        }

        /* Responsive */
        @media (max-width: 768px) {
          .payment-table {
            font-size: 16px;
          }
          .payment-table th,
          .payment-table td {
            padding: 10px 8px;
            font-size: 14px;
          }
          .status-badge {
            font-size: 12px;
            padding: 4px 10px;
            min-width: 70px;
          }
        }
      `}</style>
    </>
  );
}
